<template>
  <div>
    <v-app-bar color="#171717" class="flex-grow-0" app dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn icon @click="salir">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" class="fondo">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6 white--text"> 
            <v-avatar style=" width: 80px;">
              <img style="height: 100%; width: 100%;"
                :src="urlImagen(logo)"
                alt="Logo"
              >
            </v-avatar>
            {{ nombreGimnasio }}
            </v-list-item-title>
          <v-list-item-subtitle class="text-h6 white--text"> {{ nombreUsuario }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
          class="white--text"
        >
          <v-list-item-icon >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Utiles from '../Servicios/Utiles'
export default {
  name: "Encabezado",

  data: () => {
  const rol = localStorage.getItem("rol");

  const items = [
    // Solo para rol 1
    ...(rol === "1"
      ? [
          { title: "Inicio", icon: "mdi-view-dashboard", link: "/" },
          { title: "Usuarios", icon: "mdi-account-box", link: "/usuarios" },
          { title: "Membresías", icon: "mdi-wallet-membership", link: "/membresias" },
          { title: "Pagos", icon: "mdi-account-cash", link: "/pagos" },
          { title: "Configurar", icon: "mdi-cog", link: "/configurar" },
        ]
      : []),

    // Disponible para todos los roles (excepto "Miembros" si rol = 0)
    { title: "Registrar visita", icon: "mdi-home-account", link: "/registrar-visita" },
    { title: "Visitas", icon: "mdi-calendar-star", link: "/visitas" },
    { title: "Mi perfil", icon: "mdi-account-key", link: "/perfil" },
    { title: "Miembros", icon: "mdi-weight-lifter", link: "/miembros" }
  ];

  return {
    drawer: false,
    nombreUsuario: "",
    nombreGimnasio: "",
    logo: "",
    items,
  };
},

  mounted(){
    this.nombreUsuario = localStorage.getItem("nombreUsuario")
    this.nombreGimnasio = localStorage.getItem("nombreGimnasio")
    this.logo = localStorage.getItem("logoGimnasio")

  },

  methods:{ 
    salir(){
      localStorage.removeItem('logeado')
      localStorage.removeItem('nombreUsuario')
      localStorage.removeItem('idUsuario')
      window.location.reload()
    },

    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

  }
};
</script>
<style>

.fondo {
  background-color: #000000 !important;
background-image: none;
background-attachment: fixed;
background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Encabezado.vue